import React from 'react';

import useLediumPage from '@client/hooks/useLediumPage';
import { usePageStore } from '@client/store/pageStore/context/pageContext';

import LightRecipesView from './LightRecipesView';

const LightRecipes = () => {
    const {
        pageState: { formData }
    } = usePageStore();

    const { mainMenu, onSave } = useLediumPage({
        saveDataMap: () => ({
            name: formData.name,
            description: formData.description,
            spectrogram: formData.spectrogram,
            csvData: formData.csvData,
            spectrogramRanges: formData.spectrogramRanges
        })
    });

    if (!formData.loaded) {
        return null;
    }

    return <LightRecipesView onSave={onSave} onClose={mainMenu} />;
};

export default LightRecipes;
